import React,{useState} from 'react'
import { countClosed, countInProgress, countOnHold, countOpen, countReopened, countSelfCanceled, countTotal } from '../statusReportServices';
import GrievanceListDialog from './GrievanceListDialog';

function SupervisorStatusCounter({reportData,aassignedGrievanceType,masters,getMasterLabel}) {

    const [dialogStatus, setDialogStatus] = useState(false);
    const [grievanceList,setGrievanceList] = useState(null);

    const handleCountClick = ( func, type) =>{
        let data = func(reportData,type);
        setGrievanceList(data);
        setDialogStatus(true);
    }

    return (
        <>
                <div className='row mb-2'>
                    <div className='col-md-10'>
                        <div className='row'>
                            <div className="col-md-2 ">
                                <div className="card bg-primary text-white shadow p-1">
                                    <div>Open</div>
                                    <span className="text-center">
                                        <h1 type="button" onClick={()=>handleCountClick(countOpen)}>
                                            {countOpen(reportData).length}
                                        </h1>
                                    </span>
                                </div>
                            </div>

                            <div className="col-md-2 ">
                                <div className="card bg-danger text-white shadow p-1">
                                    <div>Reopened</div>
                                    <span className="text-center">
                                        <h1 type="button" onClick={()=>handleCountClick(countReopened)}>
                                            {countReopened(reportData).length}
                                        </h1>
                                    </span>
                                </div>
                            </div>

                            <div className="col-md-2 ">
                                <div className="card bg-warning shadow p-1">
                                    <div>In Progress</div>
                                    <span className="text-center">
                                        <h1 type="button" onClick={()=>handleCountClick(countInProgress)}>
                                            {countInProgress(reportData).length}
                                        </h1>
                                    </span>
                                </div>
                            </div>

                            <div className="col-md-2 ">
                                <div className="card bg-success text-white shadow p-1">
                                    <div>Closed</div>
                                    <span className="text-center">
                                        <h1 type="button" onClick={()=>handleCountClick(countClosed)}>
                                            {countClosed(reportData).length}
                                        </h1>
                                    </span>
                                </div>
                            </div>

                            <div className="col-md-2 ">
                                <div className="card bg-info shadow p-1">
                                    <div>Self Canceled</div>
                                    <span className="text-center">
                                        <h1 type="button" onClick={()=>handleCountClick(countSelfCanceled)}>
                                            {countSelfCanceled(reportData).length}
                                        </h1>
                                    </span>
                                </div>
                            </div>

                            <div className="col-md-2 ">
                                <div className="card bg-light shadow p-1">
                                    <div>On Hold</div>
                                    <span className="text-center">
                                        <h1 type="button" onClick={()=>handleCountClick(countOnHold)}>
                                            {countOnHold(reportData).length}
                                        </h1>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-2'>
                        <div className="card bg-dark text-white shadow p-1">
                            <div>Total</div>
                            <span className="text-center">
                                <h1 type="button" onClick={()=>handleCountClick(countTotal)}>
                                    {countTotal(reportData).length}
                                </h1>
                            </span>
                        </div>
                    </div>
                </div>
                    
                    <div className='row'>
                        <div className='col-md-12'>                            
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th>Grievance Type</th>
                                        <th className='bg-primary text-white'>Open</th>
                                        <th className='bg-danger text-white'>ReOpened</th>
                                        <th className='bg-warning'>In Progress</th>
                                        <th className='bg-success text-white'>Closed</th>
                                        <th className='bg-info'>Self Canceled</th>
                                        <th className='bg-light '>On Hold</th>
                                        <th className='bg-dark text-white'>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {aassignedGrievanceType.map(grievanceType=>
                                        <tr>
                                            <th>{getMasterLabel('grievance-type',  grievanceType)}</th>
                                            <td className='bg-primary text-white'>
                                                <button className='btn btn-link text-white' type='button' onClick={()=>handleCountClick(countOpen,grievanceType)}>
                                                    {countOpen(reportData,grievanceType).length}
                                                </button>
                                            </td>

                                            <td className='bg-danger'>
                                                <button className='btn btn-link text-white' type='button' onClick={()=>handleCountClick(countReopened,grievanceType)}>
                                                    {countReopened(reportData,grievanceType).length}
                                                </button>
                                            </td>

                                            <td className='bg-warning'>
                                                <button className='btn btn-link' type='button' onClick={()=>handleCountClick(countInProgress,grievanceType)}>
                                                    {countInProgress(reportData,grievanceType).length}
                                                </button>
                                            </td>

                                            <td className='bg-success'>
                                                <button className='btn btn-link text-white' type='button' onClick={()=>handleCountClick(countClosed,grievanceType)}>
                                                    {countClosed(reportData,grievanceType).length}
                                                </button>
                                            </td>

                                            <td className='bg-info'>
                                                <button className='btn btn-link' type='button' onClick={()=>handleCountClick(countSelfCanceled,grievanceType)}>
                                                    {countSelfCanceled(reportData,grievanceType).length}
                                                </button>
                                            </td>

                                            <td className='bg-light'>
                                                <button className='btn btn-link' type='button' onClick={()=>handleCountClick(countOnHold,grievanceType)}>
                                                    {countOnHold(reportData,grievanceType).length}
                                                </button>
                                            </td>

                                            <td className='bg-dark'>
                                                <button className='btn btn-link text-white' type='button' onClick={()=>handleCountClick(countTotal,grievanceType)}>
                                                    {countTotal(reportData,grievanceType).length}
                                                </button>
                                            </td>
                                            
                                            
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

            <GrievanceListDialog grievanceList={grievanceList} dialogStatus={dialogStatus} setDialogStatus={setDialogStatus} getMasterLabel={getMasterLabel} />
        </>
    )
}

export default SupervisorStatusCounter